import { IGrupos } from '../../interface';
import { ColumnsType } from 'antd/lib/table';
import { useTableScroll } from '../../hooks/useTableScroll';
import { useGrupoContext } from '../../context/GroupContext';
import { useEffect, useRef } from 'react';
import { useColumnDateTimeSearch } from '../../../../hooks/FilterTable/date';
import { DeleteOutlined, ProfileOutlined } from '@ant-design/icons';
import { useGetColumnSearchPropsTypeString } from '../../../../hooks/FilterTable/objString';
import { ScrollToBottomButton, ScrollToTopButton } from '../../../../components/ScrollButtunsTable';
import { Table, Button, Tooltip, Popconfirm, Typography } from 'antd';

interface ITabelaGrupoProps {
    grupoHook: any;
    theme: string;
}

const { Text } = Typography;

export const TabelaGrupo = ({ grupoHook, theme }: ITabelaGrupoProps) => {
    const {
        grupos,
        loading,
        getGrupos,
        deleteGrupo
    } = grupoHook;

    const {
        abrirModalGrupo
    } = useGrupoContext();

    const {
        tableRef,
        scrollToTable
    } = useTableScroll();

    const refContagemDoFiltro = useRef<Array<any>>([]);

    useEffect(() => {
        getGrupos();
    }, [getGrupos]);

    const columnsGrupos: ColumnsType<IGrupos> = [
        {
            title: "Nome",
            dataIndex: "nome",
            key: "nome",
            ellipsis: true,
            ...useGetColumnSearchPropsTypeString('nome')
        },
        {
            title: "Ordem de exibição",
            dataIndex: "ordem",
            key: "ordem",
            ellipsis: true,
            ...useGetColumnSearchPropsTypeString('ordem')
        },
        {
            title: "Tipo",
            dataIndex: "tipo_descricao",
            key: "tipo_descricao",
            ellipsis: true,
            ...useGetColumnSearchPropsTypeString('tipo_descricao')
        },
        {
            title: "Atualizada em",
            dataIndex: "atualizado_em",
            key: "atualizado_em",
            ...useColumnDateTimeSearch('atualizado_em'),
        },
        {
            title: "Ações",
            render: (record: IGrupos) => {
                return (
                    <>
                        <div className="divAcao" >
                            <Tooltip
                                title="Abrir Grupo"
                                color="blue"
                            >
                                <Button
                                    type="primary"
                                    icon={< ProfileOutlined />}
                                    onClick={() => abrirModalGrupo('grupo', record)} />
                            </Tooltip>
                            <Popconfirm
                                title="Deseja excluir?"
                                onConfirm={() => deleteGrupo(record.id)}
                                onCancel={() => { }}
                                okText="Sim"
                                cancelText="Não"
                            >
                                <Button
                                    type="primary"
                                    danger
                                    icon={< DeleteOutlined />}
                                />
                            </Popconfirm>
                        </div>
                    </>
                )
            },
        },
    ];

    return (
        <>
            <div ref={tableRef}>
                <Table
                    rowKey="id"
                    dataSource={grupos}
                    columns={columnsGrupos}
                    loading={loading}
                    size="small"
                    pagination={{
                        locale: { items_per_page: '' },
                        showSizeChanger: true,
                        defaultPageSize: 50,
                        position: ['bottomRight'],
                        pageSizeOptions: ['10', '20', '50', '100']
                    }}
                    title={(registros) => {
                        return (
                            <div
                                style={{
                                    backgroundColor: theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                    padding: 10,
                                    marginBottom: -8,
                                    margin: -8,
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <div
                                    style={{
                                        gap: 5,
                                        display: 'flex'
                                    }}
                                >
                                    <Button
                                        type="primary"
                                        className="btn_success_vlhbegoawrgbvr"
                                        onClick={() => abrirModalGrupo('grupo')}
                                    >
                                        Novo Grupo
                                    </Button>
                                    <Button
                                        type="primary"
                                        onClick={() => abrirModalGrupo('organizar_grupos')}
                                    >
                                        Organizar Grupos
                                    </Button>
                                    <Button
                                        type="primary"
                                        className="btn_warning_Purple_gvreihjbreobovf"
                                        onClick={() => abrirModalGrupo('republicar_grupos')}
                                    >
                                        Republicar Grupos
                                    </Button>
                                </div>
                                <ScrollToBottomButton
                                    registros={registros}
                                    onClick={() => scrollToTable('bottom')}
                                />
                                <Text>
                                    {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                        grupos.length :
                                        refContagemDoFiltro.current.length} em um total de ${grupos.length} `}
                                </Text>
                            </div>
                        )
                    }}
                    footer={(registros) => {
                        return (
                            <div style={{ textAlign: 'end' }}>
                                <ScrollToTopButton
                                    registros={registros}
                                    onClick={() => scrollToTable('top')}
                                />
                                <Text>
                                    {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                        grupos.length :
                                        refContagemDoFiltro.current.length} em um total de ${grupos.length} `}
                                </Text>
                            </div>
                        )
                    }}
                />
            </div>
        </>
    );
};
